<template>
  <!-- 案例轮播图 -->
  <div class="case-swiper-box">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="logo">
            <img style="width: 202px;height: 55px;" src="../assets/img/homePage/guojiadianwang.png">
          </div>
          <div class="staff">华中科技公司  余主任</div>
          <div class="desc">
            <span>轻骑兵低代码开发平台全面统一了公司的技术架构，完善了公司的研发体系，该平台的可视化设计器支持定制各种自定义组件，赋能公司设计团队，助力公司技术积累。</span>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="logo">
            <img src="../assets/img/homePage/case2-logo.png">
          </div>
          <div class="staff">航天科工集团某研究所  李总</div>
          <div class="desc">
            <span>轻骑兵的可视化设计器很好用，基于平台可以快速进行可视化开发，提升我们项目的研发效率，平台符合分保要求，支持多版本兼容，这对我们而言是非常重要的两点。</span>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="logo">
            <img src="../assets/img/homePage/case3-logo.png">
          </div>
          <div class="staff">联通雄安产业互联网有限公司  赵经理</div>
          <div class="desc">
            <span>轻骑兵低代码开发平台，对业务场景具备快速实现能力，可视化开发模式降低了应用软件的开发难度，开发效率大幅度提升。在客户项目中，该平台能够快速友好地同其他系统进行整合，实现数据双向交换、共享业务处理流程，同时也减轻了软件维护的负担。</span>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="logo">
            <img src="../assets/img/homePage/case4-logo.png">
          </div>
          <div class="staff">玫德集团  生经理</div>
          <div class="desc">
            <span>轻骑兵低代码开发平台显著降低了企业开发人员数量和水平的要求，能够快速响应客户需求求，灵活应用在复杂的开发场景中，降低开发人员的工作量，大幅提高编码效率。</span>
          </div>
        </div>
<!--        <div class="swiper-slide">-->
<!--          <div class="logo">-->
<!--            <img src="../assets/img/homePage/case5-logo.png">-->
<!--          </div>-->
<!--          <div class="staff">临沂城投思索信息技术有限公司  丁经理</div>-->
<!--          <div class="desc">-->
<!--            <span>轻骑兵低代码开发平台具有可视化低代码开发、开发组件丰富、高安全性等特性，全面适配了国产化环境。我公司采用轻骑兵低代码开发平台大大提升了软件系统开发速度和质量，对降低软件开发成本效果显著。</span>-->
<!--          </div>-->
<!--        </div>-->
        <div class="swiper-slide">
          <div class="logo">
            <img src="../assets/img/homePage/case6-logo.png">
          </div>
          <div class="staff">中泰证券  梁经理</div>
          <div class="desc">
            <span>轻骑兵低代码开发平台统一了后续公司平台的技术框架，各部门的开发成果以组件的形式得到了积累复用，提高了开发效率，极大的减少了不同系统中互联互通的成本，避免了资源的浪费。</span>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="logo">
            <img src="../assets/img/homePage/case7-logo.png">
          </div>
          <div class="staff">南方电网数字电网集团（贵州）有限公司 生产应用部</div>
          <div class="desc">
            <span>轻骑兵低代码开发平台为微应用智慧管理工具落地筑牢了基础，交付团队专业严谨、高效协作，为数字电网的建设提质升级提供了坚实支撑。</span>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="logo">
            <img src="../assets/img/homePage/case8-logo.png">
          </div>
          <div class="staff">中国电建集团某设计研究院 李主任</div>
          <div class="desc">
            <span>轻骑兵低代码开发平台支持可视化拖拽快速实现项目需求，组件封装能力突出，助力我们有效沉淀自有研发资产，形成可复用技术资源体系。</span>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="logo">
            <img src="../assets/img/homePage/case9-logo.jpg">
          </div>
          <div class="staff">北京金风慧能技术有限公司 数字化项目负责人</div>
          <div class="desc">
            <span>轻骑兵低代码开发平台可视化开发大幅降低了开发门槛，交付周期缩短50%，原型到交付一体化落地，有效减少需求偏差导致的返工，提升交付质量。</span>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="logo">
            <img src="../assets/img/homePage/case10-logo.png">
          </div>
          <div class="staff">新天智汇能源科技（雄安）有限公司 数字化负责人</div>
          <div class="desc">
            <span>轻骑兵低代码开发平台可与多种产品全协同发力，80%功能拖拽即可完成，快速落地核心需求的同时，丰富业务场景覆盖，全面提升数字化运营效能。</span>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="logo">
            <img src="../assets/img/homePage/case11-logo.png">
          </div>
          <div class="staff">中信泰富特钢集团 智能及信息化部</div>
          <div class="desc">
            <span>轻骑兵低代码开发平台实现高代码与可视化流程深度融合，适配复杂业务定制需求，在人力模块应用中复刻功能并优化，大幅提升数字化运营效能。</span>
          </div>
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation } from 'swiper';
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css'

Swiper.use([Navigation]);

export default {
  name: 'CaseSwiper',
  props: {
  },
  data() {
    return {
    };
  },
  mounted() {
    const self = this;
    var mySwiper = new Swiper ('.swiper-container', {
      slidesPerView: 3,
      spaceBetween: -118,
      centeredSlides: true,
      loop: true, // 循环模式选项
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        //当切换时触发的方法
        slideChange: function(e) {
          // console.log(e.activeIndex, 'e.activeIndex');
          self.$emit('changeBg', e.activeIndex % 6);
        }
      }
    });
  },
};
</script>

<style scoped>
.case-swiper-box {width: 925px;position: relative;padding: 50px 50px 50px 82px;background: linear-gradient(180deg, rgba(16, 126, 246, 0.2) 0%, rgba(40, 66, 119, 0.57) 100%);}
.swiper-container {overflow: hidden;}
.swiper-wrapper {width: 100%;height: 100%;}
.swiper-slide {
  position: relative;
  top: 30px;
  font-size: 18px;
  height: 260px;
  transition: 300ms;
  transform: scale(1);
  padding: 15px 30px 0;
  background: linear-gradient(180deg, #FFF 0%, #E9F0FF 100%);
  border-radius: 5px;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
}
.swiper-slide-active {top: 0;width: 362px !important;height: 328px;transform: scale(1);padding: 24px 40px 0;z-index: 9;}
.swiper-slide .logo {transform: scale(0.5); width: 100%;position: relative;left: -25%;}
.swiper-slide .logo img {width: auto;}
.staff {margin: 12px 0;font-size: 12px;font-weight: bold;line-height: 18px;}
.desc {font-size: 12px;font-weight: 400;line-height: 18px;}
.desc span {transform: scale(0.83);}
.swiper-slide-active .logo {transform: scale(1);left: 0;}
.swiper-slide-active .logo img {width: auto;}
.swiper-slide-active .staff {margin: 24px 0;font-size: 16px;line-height: 22px;}
.swiper-slide-active .desc {font-size: 14px;font-weight: 400;line-height: 22px;}
.swiper-slide-active .desc span {transform: scale(1);}
.swiper-button-prev, .swiper-button-next {width: 52px;height: 52px;top: 164px;}
.swiper-button-prev {background: url('../assets/img/homePage/case-left.png') no-repeat;left: 198px;}
.swiper-button-next {background: url('../assets/img/homePage/case-right.png') no-repeat;right: 175px;}
.swiper-button-prev::after, .swiper-button-next::after {display: none;}
.swiper-slide-next {z-index: 8;}
</style>



// WEBPACK FOOTER //
// src/components/CaseSwiper.vue